module.exports = __webpack_public_path__ + "img/live09.20c617ea.png";